import { useFirestoreAllID } from '../../firebase/useFirestore';

const FundName = ({id}) => {

    const funds = useFirestoreAllID('Funds', id ? id : '')

  return (
    <>
        {funds && funds.map((item, index) => (
            <>
                {item.Name}
            </>
        ))}
    </>
  )
}

export default FundName